<template>
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img class="img-fluid logo-dark mb-2" src="@/assets/img/testpal-full.png" alt="Logo" />
        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Forgot Password?</h1>
              <p class="account-subtitle">
                Enter your email and we'll send you a link to reset your password
              </p>

              <div v-if="success" class="alert alert-success">
                Password reset link has been sent to your email. Please check your inbox.
              </div>

              <form v-else @submit.prevent="handleSubmit">
                <div class="input-block mb-3">
                  <label class="form-label">Email <span class="text-danger">*</span></label>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div v-if="error" class="alert alert-danger mb-3">
                  {{ error }}
                </div>

                <div class="input-block mb-3">
                  <button type="submit" class="btn btn-primary w-100" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    Send Reset Link
                  </button>
                </div>

                <div class="text-center">
                  <router-link to="/" class="text-muted">
                    <vue-feather type="arrow-left" class="me-1" size="16" />
                    Back to Login
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'ForgotPassword',
  setup() {
    const authStore = useAuthStore()

    const email = ref('')
    const loading = ref(false)
    const error = ref('')
    const success = ref(false)

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      try {
        await authStore.forgotPassword(email.value)
        success.value = true
      } catch (err) {
        error.value = err
      } finally {
        loading.value = false
      }
    }

    return {
      email,
      loading,
      error,
      success,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.login-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8f9fa;
}

.login-wrapper {
  width: 100%;
  max-width: 500px;
  padding: 20px;
}

.loginbox {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
}

.logo-dark {
  max-width: 180px;
  display: block;
  margin: 0 auto 20px;
}

h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}

.account-subtitle {
  color: #6c757d;
  text-align: center;
  margin-bottom: 30px;
}
</style>
